export interface UnAuthenticatedUser {
  email: string;
  password: string;
  user_id: number | null;
  remember_me: boolean;
}

const defaultUnAuthenticatedUser: UnAuthenticatedUser = {
  email: "",
  password: "",
  user_id: null,
  remember_me: true,
};

export const createUnAuthenticatedUser = (): UnAuthenticatedUser => {
  return { ...defaultUnAuthenticatedUser };
};
